import Persistable from "../../../storage/persistable";

export default class Stats extends Persistable {
    constructor({
        gameId,
        playId,
        period,
        teamId,
        playerId,
        fragmentId,
        category,
        values = {}
    }) {
        super();
        Object.assign(this, {
            gameId,
            playId,
            period,
            teamId,
            playerId,
            fragmentId,
            category,
            values
        });
    }
}
